import { render, staticRenderFns } from "./PersonCenter.vue?vue&type=template&id=1beb7b58&scoped=true"
import script from "./PersonCenter.vue?vue&type=script&lang=js"
export * from "./PersonCenter.vue?vue&type=script&lang=js"
import style0 from "./PersonCenter.vue?vue&type=style&index=0&id=1beb7b58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb7b58",
  null
  
)

export default component.exports